import EpicHero from '../assets/images/epic-hero.png';

import Troy from "../assets/images/originals/troy.webp";
import Cyclops from "../assets/images/originals/cyclops.webp";
import Ocean from "../assets/images/originals/ocean.jpeg";
import Circe from "../assets/images/originals/circe.webp";
import Underworld from "../assets/images/originals/underworld.webp";
import Thunder from "../assets/images/originals/thunder.jpg";
import Wisdom from "../assets/images/originals/wisdom.jpeg";
import Vengance from "../assets/images/originals/vengance.jpeg";
import Ithica from "../assets/images/originals/ithica.jpeg";

import React, { useState, useEffect } from 'react';
// import SparksBackground from './SparksBackground';

const SparkParticle = ({ delay }) => {
    return (
      <div
        className="absolute w-1 h-1 bg-red-500 rounded-full opacity-0 -z-10 overflow-hidden"
        style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          animation: `spark 3s infinite`,
          animationDelay: `${delay}s`,
        }}
      />
    );
  };

const HeroSection = ({ id }) => {

  const [isVisible, setIsVisible] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 100);
  }, []);

  const images = [
    { id: 1, src: Troy, alt: "Troy", initialTransform: '-translate-x-full scale-0' },
    { id: 2, src: Cyclops, alt: "Cyclops", initialTransform: '-translate-x-full scale-0' },
    { id: 3, src: Ocean, alt: "Ocean", initialTransform: 'translate-y-full scale-0' },
    { id: 4, src: Circe, alt: "Circe", initialTransform: 'translate-x-full scale-0' },
    { id: 5, src: Underworld, alt: "Underworld", initialTransform: 'translate-x-full scale-0' },
    { id: 6, src: Thunder, alt: "Thunder", initialTransform: '-translate-x-full scale-0' },
    { id: 7, src: Wisdom, alt: "Wisdom", initialTransform: '-translate-y-full scale-0' },
    { id: 8, src: Vengance, alt: "Vengance", initialTransform: 'translate-y-full scale-0' },
    { id: 9, src: Ithica, alt: "Ithica", initialTransform: 'translate-x-full scale-0' },
  ];

  const sparkCount = 50;
  const sparks = Array.from({ length: sparkCount }, (_, i) => (
    <SparkParticle key={i} delay={Math.random() * 2} />
  ));

  return (
    <div className="relative w-full min-h-screen flex flex-col bg-black overflow-hidden">
    {/* <SparksBackground /> */}
    <style>{`
    @keyframes spark {
      0% { 
        transform: translate(0, 0) scale(0);
        opacity: 0;
      }
      50% { 
        transform: translate(${Math.random() * 100 - 50}px, ${Math.random() * 100 - 50}px) scale(1);
        opacity: 0.8;
      }
      100% { 
        transform: translate(${Math.random() * 200 - 100}px, ${Math.random() * 200 - 100}px) scale(0);
        opacity: 0;
      }
    }
  `}</style>
  <div className="absolute inset-0 pointer-events-none z-0">
    {sparks}
  </div>


      <div className="flex-1 flex flex-col items-center justify-center p-4 md:p-2">
        {/* Mobile Hero Image */}
        <div className="block md:hidden w-full px-4">
          <div className={`relative overflow-hidden transition-all duration-1000 ease-in-out z-10
            ${isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-full scale-95'}`}
          >
            <img 
              src={EpicHero}
              alt="Epic Hero"
              className="w-full aspect-[3/4] object-cover rounded shadow-lg shadow-red-900/20"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-red-900/20 to-transparent pointer-events-none" />
          </div>
        </div>

        {/* Desktop/Tablet Grid */}
        <div className="hidden md:flex flex-col gap-8 w-full max-w-7xl px-4 mx-auto">
          {/* Top Row - All same size */}
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-2">
            {images.slice(0, 5).map((image, index) => (
              <div
                key={image.id}
                className={`relative w-full aspect-[2/3] transition-all duration-1000 ease-in-out z-10
                  ${isVisible ? 'opacity-100 translate-x-0 translate-y-0 scale-100' : `opacity-0 ${image.initialTransform}`}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <img 
                  src={image.src}
                  alt={image.alt}
                  className="absolute inset-0 w-full h-full object-cover rounded shadow-lg shadow-red-900/20"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-red-900/20 to-transparent pointer-events-none" />
              </div>
            ))}
          </div>
          
          {/* Bottom Row - Centered, same size as top */}
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-2 md:justify-center lg:w-4/5 mx-auto">
            {images.slice(5).map((image, index) => (
              <div
                key={image.id}
                className={`relative w-full aspect-[2/3] transition-all duration-1000 ease-in-out z-10
                  ${isVisible ? 'opacity-100 translate-x-0 translate-y-0 scale-100' : `opacity-0 ${image.initialTransform}`}`}
                style={{ transitionDelay: `${(index + 5) * 200}ms` }}
              >
                <img 
                  src={image.src}
                  alt={image.alt}
                  className="absolute inset-0 w-full h-full object-cover rounded shadow-lg shadow-red-900/20"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-red-900/20 to-transparent pointer-events-none" />
              </div>
            ))}
          </div>
        </div>

        {/* Responsive Buttons */}
        {/* <div className={`flex flex-col sm:flex-row justify-center gap-4 w-full max-w-md transition-all duration-1000
          ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`}
          style={{ transitionDelay: `${images.length * 200}ms` }}
        >
          <button className="w-full sm:w-auto px-8 py-4 bg-red-900 text-white font-bold tracking-wider 
                          uppercase hover:bg-red-800 transition-all duration-300
                          shadow-lg shadow-red-900/50 hover:shadow-red-900/70">
            Book Tickets
          </button>
          <button className="w-full sm:w-auto px-8 py-4 border-2 border-red-900 text-red-500 font-bold 
                          tracking-wider uppercase hover:bg-red-900/10 
                          transition-all duration-300 shadow-lg shadow-red-900/50">
            Learn More
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default HeroSection;